module.exports = __webpack_public_path__ + "static/media/iMac.b502fa65.png";